<template>
    <div class="work-order" data-automation="WorkOrder">
        <div class="work-order-content">
            <my-header show-go-home show-user-name show-work-order></my-header>
            <!-- 内容 -->
            <div class="work-order-main">
                <!-- 工单列表 -->
                <work-list
                    ref="refWorkList"
                    @on-click-order="onClickOrder"
                    :is-user="isUser"
                ></work-list>

                <!-- 工单详情 -->
                <order-detail ref="refOrderDetail" :is-user="isUser"></order-detail>
            </div>
        </div>
    </div>
</template>

<script>
import myHeader from '@c/myHeader/myHeader';
import mySide from '@c/mySide/mySide';
import orderDetail from './components/orderDetail';
import workList from './components/workList';

export default {
  name: 'WorkOrder',
  components: {
    myHeader,
    mySide,
    orderDetail,
    workList
  },
  data() {
    return {
      isCollapse: false, // 迷你侧边栏是否显示
      userData: {}, // 用户信息
      isUser: true
    };
  },
  created() {
    this.userData = this.$store.state.login.userData;
    this.checkRole();
    this.$getMenu();
  },

  methods: {
    /**
         * 退出登录
         */
    logout() {
      this.$api.login.logout();
      this.$store.commit('logout');
      this.$router.push('/login');
      this.$uxModal.hide();
    },
    // 点击工单
    onClickOrder(data) {
      this.$refs.refOrderDetail.clickOrder(data);
    },
    // 工单结束
    overOrder() {
      this.$refs.refWorkList.overOrder();
    },
    // 查询当前用户角色
    checkRole() {
      this.$api.workOrder
        .checkRole({ userId: this.userData.id }, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.isUser = String(res.data) === '0';
          }
        });
    }
  },

  computed: {
    breadData() {
      return this.$route.meta.bread;
    }
  }
};
</script>

<style lang="scss" scoped>
.work-order {
    position: relative;
    width: 100%;
    overflow: auto;
    height: 100%;

    .my-header {
        position: relative;
        box-shadow: 0px 2px 6px 0px $color-box-shadow;
        background: #fff;
        flex: 0 0 auto;
    }

    .work-order-content {
        display: flex;
        position: relative;
        min-width: 1280px;
        min-height: 800px;
        height: 100%;
        z-index: 2;
        flex-direction: column;
    }

    .work-order-main {
        display: flex;
        flex: 1;
        overflow: hidden;
    }

    .work-list {
        flex: 0 0 auto;
        width: 320px;
        height: 100%;
    }

    .order-detail {
        flex: 1;
        height: 100%;
    }
}
</style>
